import { useState } from "react";
import classNames from "classnames";
import { useItemGroups } from "atoms/itemsGropAtom";

import { BaseLayout } from "components/BaseLayout/BaseLayout";

import { SearchBar, ProductsList, ProductsFooter, Header } from "./components";
import { useGetProducts } from "./api";
import styles from "./styles.module.scss";

export const Products = (): JSX.Element => {
  const [searchText, setSearchText] = useState("");
  const { itemGroupsState } = useItemGroups();

  const { data } = useGetProducts({
    group: +(itemGroupsState.activeItemsGroup?.itemgroupid || "") || undefined,
  });

  return (
    <BaseLayout
      className={classNames("ml-2 mt-3 mb-3", styles.container)}
      header={<Header />}
      footer={<ProductsFooter />}
    >
      <div className={styles.productsContainer}>
        <SearchBar onSearch={setSearchText} />
        <ProductsList items={data || []} searchText={searchText} />
      </div>
    </BaseLayout>
  );
};
